import React, { useEffect, useState } from 'react';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
type Purchase = {
  buyer: string;
  city: string;
  emoji: string;
};
type ConnectionInfo = {
  effectiveType?: string;
  saveData?: boolean;
};
const PURCHASES: Purchase[] = [{
  buyer: 'Valentina G.',
  city: 'Montevideo',
  emoji: '🍎'
}, {
  buyer: 'Marcela F.',
  city: 'Rivera',
  emoji: '🧁'
}, {
  buyer: 'Carolina P.',
  city: 'Canelones',
  emoji: '🍇'
}, {
  buyer: 'Fernando R.',
  city: 'Ciudad de la Costa',
  emoji: '🥪'
}, {
  buyer: 'Laura M.',
  city: 'Montevideo',
  emoji: '🍓'
}];
function canShowSocialProof() {
  const connection = (navigator as Navigator & {
    connection?: ConnectionInfo;
  }).connection;
  return !connection?.saveData && connection?.effectiveType !== 'slow-2g' && connection?.effectiveType !== '2g';
}
export function SocialProofToast() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [closed, setClosed] = useState(false);
  const [enabled, setEnabled] = useState(false);
  useEffect(() => {
    const updateAvailability = () => setEnabled(document.visibilityState === 'visible' && canShowSocialProof());
    updateAvailability();
    document.addEventListener('visibilitychange', updateAvailability);
    return () => document.removeEventListener('visibilitychange', updateAvailability);
  }, []);
  useEffect(() => {
    if (closed || !enabled) {
      setVisible(false);
      return;
    }
    let nextToast: number | undefined;
    const initialToast = window.setTimeout(() => setVisible(true), 3200);
    const cycle = window.setInterval(() => {
      setVisible(false);
      nextToast = window.setTimeout(() => {
        setIndex(current => (current + 1) % PURCHASES.length);
        setVisible(true);
      }, 300);
    }, 14000);
    return () => {
      window.clearTimeout(initialToast);
      window.clearTimeout(nextToast);
      window.clearInterval(cycle);
    };
  }, [closed, enabled]);
  if (closed || !visible) return null;
  const purchase = PURCHASES[index];
  return <aside aria-live="polite" className="fixed bottom-4 left-4 z-[60] flex w-72 max-w-[calc(100vw-2rem)] gap-3 rounded-2xl border border-orange-100 bg-white p-3 pr-8 shadow-[0_10px_30px_rgba(13,59,110,0.18)]" data-id="element-227">
      <button type="button" aria-label="Cerrar notificación" onClick={() => setClosed(true)} className="absolute right-2 top-2 rounded p-1 text-brand-gray hover:text-brand-deep focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-blue" data-id="element-228">
        <XIcon className="h-4 w-4" data-id="element-229" />
      </button>
      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-orange-50 text-xl" data-id="element-230">
        {purchase.emoji}
      </span>
      <div className="min-w-0" data-id="element-231">
        <p className="flex items-center gap-1 text-[11px] font-bold uppercase tracking-wide text-brand-green" data-id="element-232">
          <CheckCircle2Icon className="h-3.5 w-3.5" data-id="element-233" /> Compra verificada
        </p>
        <p className="mt-0.5 text-sm leading-tight text-brand-text" data-id="element-234">
          <strong className="text-brand-deep" data-id="element-235">{purchase.buyer}</strong> de{' '}
          {purchase.city} eligió{' '}
          <strong className="text-brand-orange" data-id="element-236">Meriendas que Acompañan</strong>
        </p>
        <p className="mt-1 text-[11px] text-brand-gray" data-id="element-237">hace unos minutos</p>
      </div>
    </aside>;
}